var map = {
	"./aral_komfort.svg": 3245,
	"./aral_plus.svg": 3246,
	"./bp_bonus.svg": 3247,
	"./bp_komfort.svg": 3248,
	"./bp_komfort_prepaid.svg": 3249,
	"./bp_plus.svg": 3250,
	"./fuel-card-active.svg": 3251,
	"./fuel-card-inactive.svg": 3252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3244;